module.exports = __webpack_public_path__ + "public/SideMenuIcons/changePassword.svg?fd021ee3";